import './instruments'

import '@forest/native-diagnostics'

console.log('typeof Intl:', typeof Intl)

import { initializeNativeBridge } from '@forest/native-services'
import { tagFailure, type ServiceLevelStatus } from '@forest/paywall-core'
import { appVersion, language } from './lib/params'
import { overwriteGetLocale, type Locale } from './paraglide/runtime'
import { api } from './services/api'
import { showDataLoadFailDialog } from './store/error-dialog'
import { $serviceLevelReady, $serviceLevelStatus } from './store/service-level'
import { userInfoSource } from './store/user-info'

overwriteGetLocale(() => language as Locale)

initializeNativeBridge({
  appVersion: appVersion ?? '0.0.0',
  bifrost: { enableDebug: import.meta.env.MODE !== 'production' },
})

async function getServiceLevelStatus(
  userId: number,
): Promise<ServiceLevelStatus> {
  return api.service
    .get(`user/users/${userId}/service-levels/status`)
    .json<ServiceLevelStatus>()
}

export async function bootstrapEntitlement(): Promise<void> {
  try {
    const userInfo = await userInfoSource.getReady().catch((error: unknown) => {
      throw tagFailure(error, 'load_user_info')
    })
    const status = await getServiceLevelStatus(userInfo.user_id).catch(
      (error: unknown) => {
        throw tagFailure(error, 'load_service_level')
      },
    )
    $serviceLevelStatus.set(status)
    $serviceLevelReady.set(true)
  } catch (error) {
    console.error('bootstrapEntitlement failed', error)
    showDataLoadFailDialog({
      source: 'failed_to_bootstrap_entitlement',
      error,
    })
  }
}
